<template>
  <div v-if="caseData">
      <template>
        <v-tabs
          v-model="tab"
          color="#e1e1e1"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab :key="1" ripple class="primary--text">
            Client Details
          </v-tab>

          <v-tab :key="2" ripple class="primary--text" :disabled="!tab2active">
            Packages and Vendors
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item :key="1">
            <v-card>
              <v-card-text>

                <v-layout row wrap>
                  <v-flex xs12>


                    <v-layout row wrap align-center>
                      <v-flex xs12>
                        <h3>Next-of-Kin's Details</h3>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap align-center>
                      <v-flex xs4>
                      </v-flex>
                      <v-flex xs8>
                        <v-radio-group
                          class="large-radio"
                          large
                          :column="false"
                          v-model="clientRelation"
                        >
                          <v-radio
                            :label="'Returning Customer'"
                            :value="'returning'"
                          ></v-radio>
                          <v-radio
                            :label="'New Customer'"
                            :value="'new'"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap align-center>
                      <v-flex xs4>
                        <v-subheader class="required">Client (Next of Kin):</v-subheader>
                      </v-flex>
                      <v-flex xs8>
                        <dfs-client-add-form @namechanged="onNameChanged" @valid:changed="onFormValidate" :selected-client="selectedClient" :client-name="caseData && caseData.client && caseData.client.name" />
                      </v-flex>
                    </v-layout>

                    <dfs-forms :caseid="caseid" @valid:changed="onFormValidate"></dfs-forms>
                  </v-flex>
                </v-layout>

                <DfsServiceAgreementCheckList @agreement:status="checkAgreementStatus" @valid:changed="onFormValidate"/>
                <DfsServiceAgreementClientData :clientName="clientName" @clientdata:input="checkClientDataStatus" :newreturn="clientRelation" @valid:changed="onFormValidate"/>

                <div v-if="!caseData.client_signature">
                  <h3 class="required">Draw Client Signature</h3>

                  <v-tooltip top>
                    <v-btn slot="activator" flat icon @click="clearSignature">
                      <v-icon color="red">undo</v-icon>
                    </v-btn>
                    Clear signature
                  </v-tooltip>

                  <div class="sign-pad">
                    <VueSignaturePad
                      height="250px"
                      width="500px"
                      ref="signaturePad"
                    />
                  </div>
                </div>
                <div v-else>
                  <h3 class="required">Client Signature</h3>
                  <v-img :src="caseData.client_signature" />
                </div>

              </v-card-text>
              <v-card-actions>

                <v-btn
                  color="primary"
                  block
                  @click.native="saveCase"
                  :loading="loading.SaveCaseBtn"
                  :disabled="disabled.SaveCaseBtn">
                  Save case
                </v-btn>

              </v-card-actions>
            </v-card>
            <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
          </v-tab-item>
          <v-tab-item :key="2">
            <SelectPlanAndVendors :caseData="caseData" :case-id="caseid" editable></SelectPlanAndVendors>
          </v-tab-item>
        </v-tabs-items>
      </template>
      <ConfirmationDialog ref="confirm" />
      <v-dialog
        v-model="showAlert"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text class="flex-alert-center">
            <v-icon dark right class="flex-alert-notification-check">error</v-icon> {{ alertMessage }}
          </v-card-text>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
  import DfsServiceAgreementClientData from '@/components/DfsServiceAgreementClientData'
  import DfsServiceAgreement from '@/components/DfsServiceAgreement'
  import DfsServiceAgreementCheckList from '@/components/DfsServiceAgreementCheckList'
  import dfsForms from '@/components/resources/Forms'
  import dfsClientAddForm from '@/components/ClientAddForm'
  import AppMainDialog from '@/components/AppMainDialog'
  import SelectPlanAndVendors from '@/components/SelectPlanAndVendors'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
  import { mapGetters } from 'vuex'

  export default {
    components: { dfsForms, dfsClientAddForm, AppMainDialog, DfsServiceAgreement, DfsServiceAgreementCheckList, DfsServiceAgreementClientData, SelectPlanAndVendors, ConfirmationDialog },
    props: {
      caseid: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        tab: null,
        agreementFormData: null,
        clientFormData: null,
        createClient: false,
        selectedClient: null,
        clientRelation: 'new',
        notSelectedLabel: 'not selected',
        validatedForms: 0,
        clientName: '',
        agreementIsInComplete: true,
        disabled: {
          SaveCaseBtn: true
        },
        loading: {
          SaveCaseBtn: false,
          clients: false
        },
        clientDataIsInComplete: true,
        dialogOpen: false,
        formPriceTableHeaders: [
          { text: 'DESCRIPTION', sortable: false },
          { text: 'PRICE', sortable: false },
          { text: 'REMARKS', sortable: false }
        ],
        dialogMessage: '',
        caseData: null,
        formSubmitted: false,
        showAlert: false,
        alertMessage: null
      }
    },
    computed: {
      ...mapGetters({
        onBoardClientForm: 'getOnBoardClientForm'
      }),
      validateClientsList () {
        return 'required|'
      },
      tab2active () {
        return this.formSubmitted || (this.caseData && this.caseData.clients_id)
      }
    },
    watch: {
      validatedForms (count) {
        if (count === 4) {
          this.disabled.SaveCaseBtn = false
        } else {
          this.disabled.SaveCaseBtn = true
        }
      }
    },
    methods: {
      clientFilter (item, queryText, itemText) {
        const textOne = item.name.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1
      },
      clearSignature () {
        this.$refs.signaturePad.undoSignature()
      },
      onFormValidate (isValid) {
        isValid ? this.validatedForms++ : this.validatedForms--
      },
      checkIfNewClientAdded () {

      },
      checkClientDataStatus (object) {
        this.clientFormData = object
      },
      checkAgreementStatus (status, object) {
        this.agreementFormData = object
        this.agreementIsInComplete = !status
      },
      onNameChanged (newVal) {
        this.clientName = newVal
      },
      saveCase () {
        this.disabled.SaveCaseBtn = this.loading.SaveCaseBtn = true
        const dateOfDeath = this.moment(this.onBoardClientForm.answer.form_answers.main_form.deceased_date).format('YYYY-MM-DD')
        if (!this.caseData.client_signature) {
          let signature = this.$refs.signaturePad.saveSignature()

          if (!signature.isEmpty) {
            this.$store.dispatch('updateCase', {
              case_id: this.caseid,
              payload: {
                client_signature: signature.data,
                date_of_death: dateOfDeath
              }
            })
          } else {
            this.alertMessage = 'Signature is missing. Please, add a signature first'
            this.showAlert = true
            setTimeout(() => {
              this.showAlert = false
              this.disabled.SaveCaseBtn = this.loading.SaveCaseBtn = false
            }, 2000)
            return
          }
        } else {
          this.$store.dispatch('updateCase', {
            case_id: this.caseid,
            payload: {
              date_of_death: dateOfDeath
            }
          })
        }

        if (this.createClient) {
          this.$store.dispatch('createClient', this.clientName).then((clientId) => {
            this.selectedClient = clientId
            this.$store.dispatch('updateCase', {case_id: this.caseid, payload: {clients_id: clientId}})
            this.createClient = false
          })
        }

        this.$store.dispatch('storeOnBoardForm').then((result) => {
          this.dialogMessage = 'Case successfully added'
          this.dialogOpen = true
          this.loading.SaveCaseBtn = this.disabled.SaveCaseBtn = false
          this.formSubmitted = true
          this.tab = 1
        })
      },
      checkDataSave (event) {
        if (this.formSubmitted || (this.caseData && this.caseData.clients_id)) return
        event.preventDefault()
        event.returnValue = "Data wasn't saved. Leaving the page will cause data lose."
      }
    },
    created () {
      this.$store.dispatch('clearCaseForms')

      if (!this.caseid) {
        this.$router.push({ name: 'AppointmentSchedule' })
      }

      this.$axios.get(`${this.$store.getters.config.api_host}/api/cases/${this.caseid}`).then(response => {
        const res = response.data.additional_data[0]
        this.caseData = res
        this.$store.dispatch('loadCaseForms', res)
        if (res.clients_id) {
          this.selectedClient = res.clients_id
        } else {
          this.createClient = true
        }
      })
    },
    beforeMount () {
      window.addEventListener('beforeunload', this.checkDataSave)
    },
    beforeDestroy () {
      window.removeEventListener('beforeunload', this.checkDataSave)
    },
    beforeRouteUpdate (to, from, next) {
      if (this.formSubmitted || (this.caseData && this.caseData.clients_id)) {
        next()
      } else {
        this.$refs.confirm.open('Changes you made are not saved.', 'Leave', {}).then((confirm) => {
          next()
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      if (this.formSubmitted || (this.caseData && this.caseData.clients_id)) {
        next()
      } else {
        this.$refs.confirm.open('Changes you made are not saved.', 'Leave', {}).then((confirm) => {
          next()
        })
      }
    }
  }
</script>

<style>
  .required::after {
    content: "*";
    color: red;
  }
  .sign-pad div {
    max-width: 100%;
    border: 1px solid #949494;
  }
</style>



// WEBPACK FOOTER //
// OnboardClient.vue?533155f2